export default __webpack_public_path__ + "static/media/testi3.5a572704.png";